var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApk = function SvgApk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apk_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "M24.75 24.375a.375.375 0 0 1 .75 0v.688a3.75 3.75 0 0 1 3 0v-.688a.375.375 0 0 1 .75 0V25.5q.211.159.402.348A3.75 3.75 0 0 1 30.75 28.5h-7.5a3.75 3.75 0 0 1 1.5-3zM32.25 30a.75.75 0 0 0-.75.75v3.75a.75.75 0 0 0 1.5 0v-3.75a.75.75 0 0 0-.75-.75m-10.5 0a.75.75 0 0 0-.75.75v3.75a.75.75 0 0 0 1.5 0v-3.75a.75.75 0 0 0-.75-.75m1.5 6.75h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5V30h-7.5zM28.125 27a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75m-1.875-.375a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#089953",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.756 18H7l1.98-6h2.227l1.98 6h-1.758l-1.312-4.348h-.047zm-.328-2.367h3.305v1.219H8.428zM13.764 18v-6h2.59q.668 0 1.169.264t.78.74q.277.479.277 1.117 0 .645-.287 1.116-.284.472-.8.727-.511.255-1.198.255h-1.547v-1.266h1.22q.286 0 .488-.1a.73.73 0 0 0 .314-.29.85.85 0 0 0 .111-.442.83.83 0 0 0-.111-.44.7.7 0 0 0-.314-.28 1.1 1.1 0 0 0-.489-.1h-.574V18zm5.414 0v-6h1.629v2.426h.082L22.694 12h1.898l-2.027 2.672L24.639 18h-1.945l-1.348-2.25-.539.703V18z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "apk_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgApk;